// useContainerWidth — ResizeObserver-backed content-box width of a container.
//
// The modal's inner layouts (catalog grid columns, filter compactness, basket
// table compactness) depend on their COLUMN's width, not the viewport — the
// same viewport yields different column widths depending on whether the basket
// drawer is open and which tier the modal is in. Chakra's useBreakpointValue
// can't express that, so these surfaces measure their own container.
//
// Width is the content-box (padding excluded) — thresholds are calibrated
// against the space the content actually gets. 0 until the first observe
// fires; treat 0 as "not yet measured" and fall back to the widest layout.

import { useLayoutEffect, useRef, useState } from "react";

export const useContainerWidth = <T extends HTMLElement>() => {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width;
      if (w != null) setWidth(w);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return { ref, width };
};
